// extracted by mini-css-extract-plugin
export default {"popupBody":"UploadSuccessful_popupBody__c0TGh"};